import {MenuItem, Button, Menu} from '@mui/material';
import {useState} from 'react';
import {IoMdArrowDropdown, IoMdArrowDropup} from 'react-icons/io';
import {translations} from '../../i18n/translations';
import {PlaylistType} from '../../backend/enums/playlist-type';
import {useTranslation} from 'react-i18next';
import {Pallete} from '../../theme/bluebird';
import {playlistTypes} from '../../utils/data/playlist-types';
import {useObserveViewport} from '../../hooks/observe-viewport';

type PlaylistsMenuProps = {
  playlistType: PlaylistType;
  onChangePlaylistType: (playlistType: PlaylistType) => void;
};

export const PlaylistsMenu = ({playlistType, onChangePlaylistType}: PlaylistsMenuProps) => {
  const {t} = useTranslation();
  const [playlistsMenuAnchor, setPlaylistsMenuAnchor] = useState<null | HTMLElement>(null);
  const {isRunningMobile} = useObserveViewport();

  return (
    <>
      <Button
        variant="inverted"
        color="primary"
        onClick={(event) => setPlaylistsMenuAnchor(event.currentTarget)}
        endIcon={playlistsMenuAnchor ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
      >
        {t(translations.playlist_types[playlistType])}
      </Button>
      <Menu
        id="add-devices-menu"
        anchorEl={playlistsMenuAnchor}
        open={playlistsMenuAnchor !== null}
        onClose={() => setPlaylistsMenuAnchor(null)}
        transformOrigin={{horizontal: 'right', vertical: 'top'}}
        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
        sx={{
          marginTop: '5px',
          '.MuiList-root': {
            width: isRunningMobile ? '100vw' : '160px',
            padding: '4px 0',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          },
        }}
      >
        {playlistTypes.map((playlist) => {
          return (
            <MenuItem
              key={`devices-group-option-${playlist.type}`}
              onClick={() => {
                setPlaylistsMenuAnchor(null);
                onChangePlaylistType(playlist.type);
              }}
              value={playlist.type}
              sx={{
                height: '30px',
                padding: '6px 10px',
                flexDirection: 'row',
                gap: '8px',
                alignItems: 'center',
                color: '#464646',
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '10px',
                letterSpacing: '0em',
                textAlign: 'center',
                '&:hover': {
                  backgroundColor: Pallete.blue.lighter,
                },
              }}
            >
              {t(translations.playlist_types[playlist.type])}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
